import { observer } from 'mobx-react-lite';
import TextTab from './TextTab';
import VideoTab from './VideoTab';
import DownloadPdfTab from './DownloadPdfTab';

const layouts = {
    pdf_download_section : DownloadPdfTab,
    text_tab             : TextTab,
    video_tab            : VideoTab,
};

const extractText = (value) => {
    if (!value) return ""; 
    if (typeof value === "string") return value; 
    if (typeof value === "object" && value.en) return value.en; 
    return ""; 
};

const useDetailSections = (details = {}) => {
    return details?.data?.map((detail) => {
        const Component = layouts?.[detail.layout];

        if (!Component) {
            console.warn(`Missing component for layout: ${detail?.layout}`);
            return null;
        } 

        // Extract text fields properly
        const safeAttributes = Object.fromEntries(
            Object.entries(detail.attributes || {}).map(([key, value]) => [
                key,
                extractText(value),
            ])
        );

        const pdfFile = detail.attributes?.pdf_file ?? {}; 
        return {
            title: extractText(detail.attributes?.title),
            value: detail?.layout,
            content: <Component {...safeAttributes} pdf_file={pdfFile} />,
        };
    }).filter(Boolean);
};

function ProductInfoTabs({ productDetails = {} }) {
    const sections = useDetailSections(productDetails);

    if (!sections?.length) return null;

    return (
        <div className="flex flex-col">
            {sections.map((section, index) => (
                <div key={index} className="pb-4 mb-20">                    
                    <div>
                        <h6 className="mb-10">{section?.title}</h6>
                        <div>{section?.content}</div>
                    </div>                    
                </div>
            ))}
        </div>
    );
}

export default observer(ProductInfoTabs);
